<template>
	<el-container id="guide_text">
        <div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
        <div class="guide_text"  v-loading="loading">
            <div class="title">【{{type_name}}】{{title}}</div>	
			<div class="guide_con">
				<div v-if="notifyInfo_data.content.putQuestio!=''">
					<p v-html="notifyInfo_data.content.putQuestion"></p>
					<div class="attac" v-if="notifyInfo_data.attachments&&notifyInfo_data.attachments.length">
						<div>附件：</div>
						<div class="open_attac" title="点击下载" v-for="attac_item in notifyInfo_data.attachments" :key="attac_item.url" @click="open_attac(oss+attac_item.url)">{{attac_item.title}}</div>
					</div>
                	<p class="created_at" :style="con?'padding-bottom: 30px;border-bottom: 1px solid #dddddd;':''">{{notifyInfo_data.type==1?'系统':'反馈'}}时间：{{notifyInfo_data.created_at}}</p>
				</div>
				<div v-if="con">
					<p v-html="con" style="margin-top: 30px;"></p>
                	<p class="created_at">答复时间：{{notifyInfo_data.updated_at}}</p>
				</div>
                
        	</div>
        </div>
	</el-container>
</template>

<script>
export default {
	name: 'guide'
	,data () {
		return {
			oss:this.global.oss_link,
			loading:false,
            test_tit:'详情',
            notifyInfo_data:{
                content:{},
				attachments:[]
            },
			title:'',
            con:``,
			hed:'',
            location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
                query:{page: this.$store.state.defaultIndex}
			},{
				title:"消息通知",
				router:"/web/notify",
				name: 'notify',
				query:{page:'notify'}
			}],
            notifyType:{
				attachments:[]
			},
            type_name:''
		}
	}
	,mounted:function(option){
		this.getlist()
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
        //点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//列表
		getlist(){
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
            this.$ajax.get(serverSrc + qianzui + "/notify/notifyType")
		    .then(res=>{
		    	for (let i = 0; i < res.data.data.length; i++) {
		    		this.notifyType[res.data.data[i].id] = res.data.data[i]
		    	}
                this.$ajax.get(serverSrc + qianzui + "/notify/notifyInfo",{params:{id:this.$route.query.id}})
			    .then(res=>{
                    res.data.data.content = JSON.parse(res.data.data.content)
                    this.notifyInfo_data = res.data.data
			    	this.title = res.data.data.title
			    	this.con = res.data.data.content.answerQuestion
                    this.type_name = this.notifyType[res.data.data.type].name
			    	this.loading = false
			    })
		    })
		},
		//打开
		open_attac(url){
			window.open(url)
		}
	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/notify/notify_info.vue